import type { ReactNode } from 'react';

/** Visible drag grabber — pan is wired in ResizableModalPage via useSheetHeaderDrag. */
export function DragHandle({ children }: { children?: ReactNode }) {
  return (
    <div
      data-sheet-drag-handle
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 10,
        paddingBottom: 8,
        cursor: 'grab',
        touchAction: 'none',
        userSelect: 'none',
        width: '100%',
      }}
    >
      <div
        style={{
          width: 36,
          height: 4,
          borderRadius: 2,
          background: 'var(--vkui--color_separator_primary, rgba(0,0,0,0.2))',
        }}
      />
      {children}
    </div>
  );
}
